

















import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/common/icon.vue';
import { ConfigsModuleMapper } from '@/store/modules/config';
import { ConstantsModuleMapper } from '@/store/modules/constants';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['socialNetworks']),
    ...ConstantsModuleMapper.mapGetters(['isLoaded']),
  },
});
@Component({
  components: {
    Icon,
  },
})
export default class FooterSocialComponent extends Mappers {
}
